import { render, staticRenderFns } from "./CardChartBranchStatistics.vue?vue&type=template&id=12939bfe&scoped=true&"
import script from "./CardChartBranchStatistics.vue?vue&type=script&lang=ts&"
export * from "./CardChartBranchStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12939bfe",
  null
  
)

export default component.exports